var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CED5DE",
    fillRule: "nonzero",
    d: "M16 9.333h-.667V8a3.335 3.335 0 0 0-6.666 0v1.333H8c-.733 0-1.333.6-1.333 1.334v6.666c0 .734.6 1.334 1.333 1.334h8c.733 0 1.333-.6 1.333-1.334v-6.666c0-.734-.6-1.334-1.333-1.334zm0 7.334c0 .366-.3.666-.667.666H8.667A.669.669 0 0 1 8 16.667v-5.334c0-.366.3-.666.667-.666h6.666c.367 0 .667.3.667.666v5.334zm-4-1.334c-.733 0-1.333-.6-1.333-1.333s.6-1.333 1.333-1.333 1.333.6 1.333 1.333-.6 1.333-1.333 1.333zm-2-6V8c0-1.107.893-2 2-2s2 .893 2 2v1.333h-4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockGray);
export default __webpack_public_path__ + "static/media/lock-gray.7fcef2383e3780011c4e06c626ad3696.svg";
export { ForwardRef as ReactComponent };